import React from 'react';
import video from '../m3dasset/geminadoshome.mp4';
import './bgmain.css';


function BackGroundMainHome() {
    return(
        <div className='tw'>
            <video src={video} cover autoPlay loop muted />
        </div>
    );
}

export default BackGroundMainHome;



